import React from "react";
import {styled} from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import {
    IconButton,
    Typography,
    Box,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {MotorcycleMedia} from "./details/MotorcycleMedia";
import {IMotorcycle} from "../../interfaces/Interfaces";

const Container = styled(Box)({
    display: "flex",
    alignItems: "center",
    position: "relative",
    padding: "8px",
    borderRadius: "8px",
});
const ImageContainer = styled("div")({
    width: "75px",
    height: "50px",
    borderRadius: "4px",
    overflow: "hidden",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    flexShrink: 0,
});
const MotorcycleDetails = styled("div")({
    marginLeft: "12px",
    flexGrow: 1,
});
const CloseButton = styled(IconButton)({
    position: "absolute",
    top: 0,
    right: 0,
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 10,
    borderRadius: "50%",
    "&:hover": {
        backgroundColor: "rgba(255, 0, 0, 0.8)",
        transform: "scale(1.1)",
    },
});

interface MotorcycleImageComponentProps {
    motorcycle: IMotorcycle;
    onClose: () => void;
}

export const MotorcycleImageComponent: React.FC<MotorcycleImageComponentProps> = ({
    motorcycle,
    onClose,
}) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Container sx={{
            maxWidth: {xs: "70px", sm: "100px", md: "300px"},
            height: "auto",
        }}>
            {isMobile &&
                <>
                    <ImageContainer>
                        <MotorcycleMedia motorcycle={motorcycle}/>
                    </ImageContainer>
                    <CloseButton onClick={onClose} size="small">
                        <CloseIcon fontSize="small"/>
                    </CloseButton>
                </>

            }
            {!isMobile &&
                <>
                    <ImageContainer>
                        <MotorcycleMedia motorcycle={motorcycle}/>
                    </ImageContainer>
                    <MotorcycleDetails>
                        <Typography variant="body2">
                            {motorcycle.makerName} {motorcycle.modelName}
                        </Typography>
                    </MotorcycleDetails>
                    <CloseButton onClick={onClose} size="small">
                        <CloseIcon fontSize="small"/>
                    </CloseButton>
                </>}
        </Container>
    );
};
